import { useEffect, useRef } from 'react';
import pusher from '../Singleton/pusherSingleton';
import { isFeatureEnabled } from '../../../Utils/Feature/feature_flag';

const usePusherChannel = (channelName, eventType, callback) => {
  const channelRef = useRef(null);

  useEffect(() => {
    if (!channelName || !eventType || !callback) return;
    if (isFeatureEnabled('instore_pusher_order_details_tab') === false) return;
    if (isFeatureEnabled('instore_pusher_sales_tab') == false) return;

    const channel = pusher.subscribe(channelName);
    channelRef.current = channel;

    channel.bind('pusher:subscription_succeeded', () => {
      channel.bind(eventType, callback);
    });

    return () => {
      if (channel) {
        channel.unbind(eventType);
        pusher.unsubscribe(channelName);
      }
    };
  }, [channelName, eventType, callback]);
};

export default usePusherChannel;
